import { useNavigate } from "@tanstack/react-router"

import { Button, Empty } from "@productlane/ui"

const RECONNECT_PATTERNS = [
	/reconnect linear/i,
	/connection has expired/i,
	/no longer valid/i,
	/not connected/i,
]

export function isLinearReconnectError(message?: string | null): boolean {
	if (!message) {
		return false
	}
	return RECONNECT_PATTERNS.some((pattern) => pattern.test(message))
}

interface Props {
	message?: string | null
	onRetry: () => void
	className?: string
}

export function LinearIssuesError({ message, onRetry, className }: Props) {
	const navigate = useNavigate()
	const needsReconnect = isLinearReconnectError(message)

	return (
		<Empty
			className={className}
			title={
				needsReconnect ? "Reconnect Linear" : "Couldn't load Linear issues"
			}
			text={
				needsReconnect
					? "Your Linear connection expired. Reconnect it in Settings to import issues."
					: (message ?? "Something went wrong while loading Linear issues.")
			}
			action={
				needsReconnect ? (
					<Button
						onClick={() =>
							void navigate({ to: "/settings/integrations/linear" })
						}
						variant="outline"
					>
						Open Linear settings
					</Button>
				) : (
					<Button onClick={onRetry} variant="outline">
						Try again
					</Button>
				)
			}
		/>
	)
}
